import { Button } from "@mui/material";
import { useState } from "react";
import styles from "../SuccessPlan.module.scss";
import moment from "moment-timezone";

type NoteHistoryWrapperProps = {
  noteHistories: any[];
};

const NoteHistoryWrapper = ({ noteHistories }: NoteHistoryWrapperProps) => {
  const [togglePreviousNotes, setTogglePreviousNotes] = useState(false);

  const handleTogglePreviousNotes = () => {
    setTogglePreviousNotes(!togglePreviousNotes);
  };

  return (
    <>
      {noteHistories.length > 0 && (
        <div>
          <Button
            onClick={handleTogglePreviousNotes}
            disableRipple
            disableTouchRipple
            disableFocusRipple
            sx={{
              textTransform: "none",
              ":hover": { backgroundColor: "transparent" },
              fontSize: "12px",
            }}
          >
            {togglePreviousNotes ? "Hide Previous Notes" : "View Previous Notes"}
          </Button>
          <div className={styles["sp-flex-vertical"]}>
            {togglePreviousNotes &&
              noteHistories.map((history: any, index: number) => (
                <div
                  key={history.createdDate + index}
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "start",
                    height: 200,
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    overflowY: "auto",
                    padding: 14,
                  }}
                >
                  <div style={{ fontSize: "14px" }}>
                    {moment(history.createdDate).tz("America/Los_Angeles").format("MM/DD/YYYY")}:
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: history.newValue ?? "",
                    }}
                    style={{
                      flex: 1,
                      overflowY: "auto",
                    }}
                  ></div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default NoteHistoryWrapper;
